import request from "@/utils/request";

export function token(data) {
  const formData = new URLSearchParams();
  Object.entries({
    grant_type: "password",
    ...data,
  }).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return request({
    url: "/api/oauth/token/cookie",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
}

export function refresh() {
  const formData = new URLSearchParams();
  formData.append("grant_type", "refresh_token");

  return request({
    url: "/api/oauth/token/cookie",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
    // Помечаем запрос обновления, чтобы перехватчик не показывал тосты
    // и не уводил на /login при его собственной ошибке (это решает вызывающий код).
    _refresh: true,
  });
}

export function logout() {
  return request({
    url: "/api/oauth/token/logout",
    method: "post",
  });
}
